import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import t from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {Badge} from '../atoms';
import MailLinkCell from '../atoms/MailLinkCell';
import TelLinkCell from '../atoms/TelLinkCell';
import {Bold} from '../atoms/Text';
import {daysFromUntil} from '../utils/moment';
import AmpTable, {defaultTrProps} from './Table';
import Loading from '../molecules/Loading';
import ErrorPage from '../pages/ErrorPage';
import {Query} from '@apollo/react-components';
import gql from 'graphql-tag';
import {withErrorBoundary} from '../molecules/ErrorBoundary';

const CrewChangeContainer = styled.div`
  background-color: ${props => props.theme.colors.lightGray};
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 4px;
  border-radius: 4px;
`;

const OperatorNameCell = ({original: {isCurrent, name}}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '24px',
      position: 'relative',
    }}
  >
    {isCurrent && (
      <Badge style={{position: 'absolute', top: 0, left: 0}}>C</Badge>
    )}
    <Bold>{name}</Bold>
  </div>
);

OperatorNameCell.propTypes = {
  original: t.objectOf({
    start: t.string,
    name: t.string,
  }),
};

const CrewChangeCell = ({value}) => (
  <Tooltip title={moment(value).format('DD-MM-YYYY')}>
    <CrewChangeContainer>{daysFromUntil(value)}</CrewChangeContainer>
  </Tooltip>
);

CrewChangeCell.propTypes = {
  value: t.instanceOf(Date),
};

const columns = [
  {
    Header: 'NAME & SURNAME',
    accessor: 'name',
    Cell: OperatorNameCell,
    width: 80,
  },
  {
    Header: 'ROLE',
    accessor: 'role',
    width: 45,
    getProps: () => ({
      style: {
        fontWeight: 'bold',
      },
    }),
  },
  {
    Header: 'CONTACT NUMBER',
    accessor: 'phone',
    Cell: TelLinkCell,
    width: 55,
  },
  {
    Header: 'EMAIL ADDRESS',
    accessor: 'email',
    getProps: () => ({
      style: {
        textTransform: 'lowercase',
      },
    }),
    Cell: MailLinkCell,
    width: 100,
  },
  {
    Header: 'CREW CHANGE',
    accessor: 'end',
    Cell: CrewChangeCell,
    width: 50,
  },
];

const GET_OPERATORS = gql`
  query System($id: ID!) {
    system(id: $id) {
      id
      operators {
        name
        role
        phone
        email
        start
        isCurrent
      }
    }
  }
`;

const OperatorsList = ({match}) => {
  const {
    params: {id},
  } = match;
  return (
    <Query query={GET_OPERATORS} variables={{id}}>
      {({loading, error, data}) => {
        if (error) {
          return <ErrorPage error={error} />;
        }
        if (loading) {
          return (
            <Loading loading={loading} message="Fetching operators data..." />
          );
        }
        return (
          <AmpTable
            data={data ? data.system.operators : []}
            style={{flex: 1, height: '100%', overflowY: 'auto'}}
            columns={columns}
            getTheadThProps={() => {
              return {
                style: {
                  padding: 0,
                },
              };
            }}
            getTdProps={() => {
              return {
                style: {
                  textTransform: 'capitalize',
                  padding: '0 16px 0 0',
                },
              };
            }}
            getTrProps={() => {
              return {
                ...defaultTrProps,
                isRow: false,
                style: {
                  padding: 0,
                },
              };
            }}
          />
        );
      }}
    </Query>
  );
};

OperatorsList.propTypes = {
  match: t.object,
};

export default withErrorBoundary(withRouter(OperatorsList));
